var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard_5_",
    "data-name": "dashboard (5)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.054,
    height: 22.054,
    viewBox: "0 0 22.054 22.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7081",
    "data-name": "Path 7081",
    d: "M8.5,7.351H1.608A1.61,1.61,0,0,1,0,5.743V1.608A1.61,1.61,0,0,1,1.608,0H8.5a1.61,1.61,0,0,1,1.608,1.608V5.743A1.61,1.61,0,0,1,8.5,7.351ZM1.608,1.378a.23.23,0,0,0-.23.23V5.743a.23.23,0,0,0,.23.23H8.5a.23.23,0,0,0,.23-.23V1.608a.23.23,0,0,0-.23-.23Zm0,0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7082",
    "data-name": "Path 7082",
    d: "M8.5,226.2H1.608A1.61,1.61,0,0,1,0,224.589V214.94a1.61,1.61,0,0,1,1.608-1.608H8.5a1.61,1.61,0,0,1,1.608,1.608v9.649A1.61,1.61,0,0,1,8.5,226.2ZM1.608,214.71a.23.23,0,0,0-.23.23v9.649a.23.23,0,0,0,.23.23H8.5a.23.23,0,0,0,.23-.23V214.94a.23.23,0,0,0-.23-.23Zm0,0",
    transform: "translate(0 -204.143)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7083",
    "data-name": "Path 7083",
    d: "M285.832,348.684H278.94a1.61,1.61,0,0,1-1.608-1.608V342.94a1.61,1.61,0,0,1,1.608-1.608h6.892a1.61,1.61,0,0,1,1.608,1.608v4.135A1.61,1.61,0,0,1,285.832,348.684Zm-6.892-5.973a.23.23,0,0,0-.23.23v4.135a.23.23,0,0,0,.23.23h6.892a.23.23,0,0,0,.23-.23V342.94a.23.23,0,0,0-.23-.23Zm0,0",
    transform: "translate(-265.386 -326.629)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M285.832,12.865H278.94a1.61,1.61,0,0,1-1.608-1.608V1.608A1.61,1.61,0,0,1,278.94,0h6.892a1.61,1.61,0,0,1,1.608,1.608v9.649A1.61,1.61,0,0,1,285.832,12.865ZM278.94,1.378a.23.23,0,0,0-.23.23v9.649a.23.23,0,0,0,.23.23h6.892a.23.23,0,0,0,.23-.23V1.608a.23.23,0,0,0-.23-.23Zm0,0",
    transform: "translate(-265.386)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3a1cfd04de2da739399459d5e1514459.svg";
export { ForwardRef as ReactComponent };